@if (element?.images?.length) {
    @if (settings.gallery.aspectRatio !== aspectRatio.default) {
        <div class="image-wrapper resizeble" [style.paddingTop.%]="getImagePaddingTop(element?.images[0])">
            <img [src]="element?.images[0] | fmFileUrl" alt="0" />
        </div>
    }
    @if (settings.gallery.aspectRatio === aspectRatio.default) {
        <div class="image-wrapper">
            <img [src]="element?.images[0] | fmFileUrl" alt="0" />
        </div>
    }
} @else {
    <div class="blank-wrapper">
        <img [src]="'./assets/img/websites/lpc-empty-product.png'" alt="product_blank" />
    </div>
}
<div class="card-title sp-ui-text">
    <h2 [title]="element.name.length > 20 ? element.name : ''">{{ element.name }}</h2>
</div>
@if (element.prices[0].value) {
    <div class="card-price-block sp-ui-text">
        @if (settings.typography.priceSettings.isShow) {
            <p class="card-new-price">{{ element.prices[0].value }} {{ element.prices[0].currency }}</p>
        }
        @if (element.prices[0].oldValue && settings.typography.oldPriceSettings.isShow) {
            <p class="card-old-price">{{ element.prices[0].oldValue }} {{ element.prices[0].currency }}</p>
        }
    </div>
}
@if (isSubscriptionType) {
    <div class="subscribe-block">
        (
        {{ "widget_product_subscription_period_text" | translate: { period: subscribePeriodLabel | translate } }}
        )
    </div>
}
<div class="buttonWrapper">
    @if (basketButton.isShowButton) {
        <a [class]="buttonClass" class="card-button">
            @if (basketButton.buttonIcon?.isActive) {
                <span class="icon" [innerHTML]="getIcon(basketButton.buttonIcon?.icon)"></span>
            }
            {{ basketButton.label }}
        </a>
    }
</div>
